// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.modal-backdrop[data-v-15c9e2c8] {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.4);\n}\n.modal[data-v-15c9e2c8] {\n  background: white;\n  padding: 1rem;\n  border-radius: 10px;\n  width: 400px;\n  margin: 100px auto;\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);\n}\n", ""]);
// Exports
module.exports = exports;
